<div class="container-fluid">
    <app-pagetitle title="Vendors" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title mb-4">Vendors
                        <button class="btn btn-primary btn-sm float-end" (click)="openCreateModal(vendorModal)">
                            <i class="mdi mdi-plus"></i> Add Vendor
                        </button>
                    </h4>
                    <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
                        {{ successMessage }}
                        <button type="button" class="btn-close" (click)="successMessage = ''"></button>
                    </div>
                    <div *ngIf="loading" class="text-center">Loading vendors...</div>
                    <div *ngIf="error" class="alert alert-danger" role="alert">{{ error }}</div>
                    <div class="table-responsive" *ngIf="!loading && vendors && vendors.length">
                        <table class="table table-centered">
                            <thead class="table-light">
                                <tr>
                                    <th>Name</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                    <th>Transactions</th>
                                    <th>Success Rate</th>
                                    <th>Avg Response Time</th>
                                    <th>API Endpoint</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let vendor of vendors">
                                    <td><strong>{{ vendor.name }}</strong></td>
                                    <td>{{ vendor.type }}</td>
                                    <td>
                                        <div class="badge font-size-12" [ngClass]="{
                                            'bg-success-subtle text-success': vendor.status === 'Active',
                                            'bg-warning-subtle text-warning': vendor.status === 'Inactive',
                                            'bg-danger-subtle text-danger': vendor.status === 'Suspended'
                                        }">{{ vendor.status }}</div>
                                    </td>
                                    <td>{{ vendor.transactions }}</td>
                                    <td>{{ vendor.successRate }}%</td>
                                    <td>{{ vendor.avgResponseTime }}s</td>
                                    <td><small>{{ vendor.apiEndpoint }}</small></td>
                                    <td>
                                        <a href="javascript:void(0);" class="me-3 text-primary" (click)="openEditModal(vendor, vendorModal)" ngbTooltip="Edit"><i class="mdi mdi-pencil font-size-18"></i></a>
                                        <a href="javascript:void(0);" class="me-3 text-info" (click)="checkVendorHealth(vendor)" ngbTooltip="Health Check"><i class="mdi mdi-heart-pulse font-size-18"></i></a>
                                        <a href="javascript:void(0);" class="text-danger" ngbTooltip="Delete"><i class="mdi mdi-trash-can font-size-18"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="!loading && (!vendors || vendors.length === 0)" class="text-muted">No vendors found.</div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #vendorModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Edit Vendor' : 'Create New Vendor' }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
        <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>
        <div *ngIf="error" class="alert alert-danger">{{ error }}</div>
        <form [formGroup]="vendorForm">
            <div class="mb-3">
                <label class="form-label">Vendor Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" formControlName="name" />
                <div *ngIf="vendorForm.get('name')?.hasError('required') && vendorForm.get('name')?.touched" class="text-danger small">Vendor name is required.</div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Type <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" formControlName="type" placeholder="e.g., CA Provider" />
                        <div *ngIf="vendorForm.get('type')?.hasError('required') && vendorForm.get('type')?.touched" class="text-danger small">Type is required.</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Status <span class="text-danger">*</span></label>
                        <select class="form-select" formControlName="status">
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                            <option value="Suspended">Suspended</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <label class="form-label">API Endpoint <span class="text-danger">*</span></label>
                <input type="url" class="form-control" formControlName="apiEndpoint" placeholder="https://api.example.com/v1" />
                <div *ngIf="vendorForm.get('apiEndpoint')?.hasError('required') && vendorForm.get('apiEndpoint')?.touched" class="text-danger small">API Endpoint is required.</div>
            </div>
            <div class="mb-3">
                <label class="form-label">API Key <span class="text-danger">*</span></label>
                <input type="password" class="form-control" formControlName="apiKey" />
                <div *ngIf="vendorForm.get('apiKey')?.hasError('required') && vendorForm.get('apiKey')?.touched" class="text-danger small">API Key is required.</div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Success Rate (%) <span class="text-danger">*</span></label>
                        <input type="number" class="form-control" formControlName="successRate" step="0.1" min="0" max="100" />
                        <div *ngIf="vendorForm.get('successRate')?.hasError('required') && vendorForm.get('successRate')?.touched" class="text-danger small">Success rate is required.</div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Avg Response Time (s) <span class="text-danger">*</span></label>
                        <input type="number" class="form-control" formControlName="avgResponseTime" step="0.1" min="0" />
                        <div *ngIf="vendorForm.get('avgResponseTime')?.hasError('required') && vendorForm.get('avgResponseTime')?.touched" class="text-danger small">Avg response time is required.</div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveVendor()">{{ isEditMode ? 'Update' : 'Create' }}</button>
    </div>
</ng-template>